module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAPFBMVEX/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgD/tgCRRDe+AAAAE3RSTlMAGBkbJScoSUqttbbk5ufv8fLzL02fUgAAAHFJREFUeF7t1DEOgzAQBdGPg4GFGAxz/7umdrFaR0oTyVO/eqTZKkHVZilfxHFlGUdSUDowVZLCEo9AHcG3cC04lbWBroPSQPz4TzjggAMW3M4GbidO762BP7xZ30gnHhn7FLnXjmnpm/0iZbsJui3rA3DRT29VfNwwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/selected.png
// module id = mnbs
// module chunks = 1